import { shelf_type, guarantors_limit } from './Const';
import { ChildShelf, GuarantorInfo } from './types/Template';

/**
 * 連帯債務者・保証人の人数によってリクエスト対象とする項目を絞り込む
 */
export const FilterGuarantorsShelfs = (guarantor_info:GuarantorInfo,child_shelfs: ChildShelf[],guarantors_num:number) => {
  // 連帯債務者等
  if (guarantor_info.is_guarantor) {
    if (guarantor_info.guarantor_1) { // 連帯債務者１
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_2) { // 連帯債務者２
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_3) { // 連帯債務者３
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_4) { // 連帯債務者４
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_5) { // 連帯債務者５
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_6) { // 連帯債務者６
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_7) { // 連帯債務者７
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_8) { // 連帯債務者８
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_9) { // 連帯債務者９
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_10) { // 連帯債務者１０
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_11) { // 連帯債務者１１
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_12) { // 連帯債務者１２
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_13) { // 連帯債務者１３
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_14) { // 連帯債務者１４
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if (guarantor_info.guarantor_15) { // 連帯債務者１５
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    } else if(guarantor_info.guarantor_16){ // 連帯債務者１６
      return child_shelfs
      .filter(
        child_shelf =>
          child_shelf.cb_kind === shelf_type.guarantor_1 ||
          child_shelf.cb_kind === shelf_type.guarantor_2 ||
          child_shelf.cb_kind === shelf_type.guarantor_3 ||
          child_shelf.cb_kind === shelf_type.guarantor_4 ||
          child_shelf.cb_kind === shelf_type.guarantor_5 ||
          child_shelf.cb_kind === shelf_type.guarantor_6 ||
          child_shelf.cb_kind === shelf_type.guarantor_7 ||
          child_shelf.cb_kind === shelf_type.guarantor_8 ||
          child_shelf.cb_kind === shelf_type.guarantor_9 ||
          child_shelf.cb_kind === shelf_type.guarantor_10 ||
          child_shelf.cb_kind === shelf_type.guarantor_11 ||
          child_shelf.cb_kind === shelf_type.guarantor_12 ||
          child_shelf.cb_kind === shelf_type.guarantor_13 ||
          child_shelf.cb_kind === shelf_type.guarantor_14 ||
          child_shelf.cb_kind === shelf_type.guarantor_15 ||
          child_shelf.cb_kind === shelf_type.guarantor_17 ||
          child_shelf.cb_kind === shelf_type.guarantor_18 ||
          child_shelf.cb_kind === shelf_type.guarantor_19 ||
          child_shelf.cb_kind === shelf_type.guarantor_20
      )
      .map(data => data.cb_id);
    }else if(guarantor_info.guarantor_17){ // 連帯債務者１７
      return child_shelfs
      .filter(
        child_shelf =>
          child_shelf.cb_kind === shelf_type.guarantor_1 ||
          child_shelf.cb_kind === shelf_type.guarantor_2 ||
          child_shelf.cb_kind === shelf_type.guarantor_3 ||
          child_shelf.cb_kind === shelf_type.guarantor_4 ||
          child_shelf.cb_kind === shelf_type.guarantor_5 ||
          child_shelf.cb_kind === shelf_type.guarantor_6 ||
          child_shelf.cb_kind === shelf_type.guarantor_7 ||
          child_shelf.cb_kind === shelf_type.guarantor_8 ||
          child_shelf.cb_kind === shelf_type.guarantor_9 ||
          child_shelf.cb_kind === shelf_type.guarantor_10 ||
          child_shelf.cb_kind === shelf_type.guarantor_11 ||
          child_shelf.cb_kind === shelf_type.guarantor_12 ||
          child_shelf.cb_kind === shelf_type.guarantor_13 ||
          child_shelf.cb_kind === shelf_type.guarantor_14 ||
          child_shelf.cb_kind === shelf_type.guarantor_15 ||
          child_shelf.cb_kind === shelf_type.guarantor_16 ||
          child_shelf.cb_kind === shelf_type.guarantor_18 ||
          child_shelf.cb_kind === shelf_type.guarantor_19 ||
          child_shelf.cb_kind === shelf_type.guarantor_20
      )
      .map(data => data.cb_id);
    }else if(guarantor_info.guarantor_18){ // 連帯債務者１８
      return child_shelfs
      .filter(
        child_shelf =>
          child_shelf.cb_kind === shelf_type.guarantor_1 ||
          child_shelf.cb_kind === shelf_type.guarantor_2 ||
          child_shelf.cb_kind === shelf_type.guarantor_3 ||
          child_shelf.cb_kind === shelf_type.guarantor_4 ||
          child_shelf.cb_kind === shelf_type.guarantor_5 ||
          child_shelf.cb_kind === shelf_type.guarantor_6 ||
          child_shelf.cb_kind === shelf_type.guarantor_7 ||
          child_shelf.cb_kind === shelf_type.guarantor_8 ||
          child_shelf.cb_kind === shelf_type.guarantor_9 ||
          child_shelf.cb_kind === shelf_type.guarantor_10 ||
          child_shelf.cb_kind === shelf_type.guarantor_11 ||
          child_shelf.cb_kind === shelf_type.guarantor_12 ||
          child_shelf.cb_kind === shelf_type.guarantor_13 ||
          child_shelf.cb_kind === shelf_type.guarantor_14 ||
          child_shelf.cb_kind === shelf_type.guarantor_15 ||
          child_shelf.cb_kind === shelf_type.guarantor_16 ||
          child_shelf.cb_kind === shelf_type.guarantor_17 ||
          child_shelf.cb_kind === shelf_type.guarantor_19 ||
          child_shelf.cb_kind === shelf_type.guarantor_20
      )
      .map(data => data.cb_id);
    }else if(guarantor_info.guarantor_19){ // 連帯債務者１９
      return child_shelfs
      .filter(
        child_shelf =>
          child_shelf.cb_kind === shelf_type.guarantor_1 ||
          child_shelf.cb_kind === shelf_type.guarantor_2 ||
          child_shelf.cb_kind === shelf_type.guarantor_3 ||
          child_shelf.cb_kind === shelf_type.guarantor_4 ||
          child_shelf.cb_kind === shelf_type.guarantor_5 ||
          child_shelf.cb_kind === shelf_type.guarantor_6 ||
          child_shelf.cb_kind === shelf_type.guarantor_7 ||
          child_shelf.cb_kind === shelf_type.guarantor_8 ||
          child_shelf.cb_kind === shelf_type.guarantor_9 ||
          child_shelf.cb_kind === shelf_type.guarantor_10 ||
          child_shelf.cb_kind === shelf_type.guarantor_11 ||
          child_shelf.cb_kind === shelf_type.guarantor_12 ||
          child_shelf.cb_kind === shelf_type.guarantor_13 ||
          child_shelf.cb_kind === shelf_type.guarantor_14 ||
          child_shelf.cb_kind === shelf_type.guarantor_15 ||
          child_shelf.cb_kind === shelf_type.guarantor_16 ||
          child_shelf.cb_kind === shelf_type.guarantor_17 ||
          child_shelf.cb_kind === shelf_type.guarantor_18 ||
          child_shelf.cb_kind === shelf_type.guarantor_20
      )
      .map(data => data.cb_id);
    }else if(guarantor_info.guarantor_20){ // 連帯債務者２０
      return child_shelfs
      .filter(
        child_shelf =>
          child_shelf.cb_kind === shelf_type.guarantor_1 ||
          child_shelf.cb_kind === shelf_type.guarantor_2 ||
          child_shelf.cb_kind === shelf_type.guarantor_3 ||
          child_shelf.cb_kind === shelf_type.guarantor_4 ||
          child_shelf.cb_kind === shelf_type.guarantor_5 ||
          child_shelf.cb_kind === shelf_type.guarantor_6 ||
          child_shelf.cb_kind === shelf_type.guarantor_7 ||
          child_shelf.cb_kind === shelf_type.guarantor_8 ||
          child_shelf.cb_kind === shelf_type.guarantor_9 ||
          child_shelf.cb_kind === shelf_type.guarantor_10 ||
          child_shelf.cb_kind === shelf_type.guarantor_11 ||
          child_shelf.cb_kind === shelf_type.guarantor_12 ||
          child_shelf.cb_kind === shelf_type.guarantor_13 ||
          child_shelf.cb_kind === shelf_type.guarantor_14 ||
          child_shelf.cb_kind === shelf_type.guarantor_15 ||
          child_shelf.cb_kind === shelf_type.guarantor_16 ||
          child_shelf.cb_kind === shelf_type.guarantor_17 ||
          child_shelf.cb_kind === shelf_type.guarantor_18 ||
          child_shelf.cb_kind === shelf_type.guarantor_19
      )
      .map(data => data.cb_id);
    }else {
      // Note sakuma 未選択を考慮
      return child_shelfs
        .filter(
          child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
        )
        .map(data => data.cb_id);
    }
  } else {
    switch (guarantors_num) {
      case guarantors_limit.first: // 連帯債務者１
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
          )
          .map(data => data.cb_id);
      case guarantors_limit.second: // 連帯債務者２
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.three: // 連帯債務者３
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.fourth: // 連帯債務者４
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.five: // 連帯債務者５
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.six: // 連帯債務者６
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.seven: // 連帯債務者７
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.eight: // 連帯債務者８
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.nine: // 連帯債務者９
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.ten: // 連帯債務者１０
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.eleven: // 連帯債務者１１
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.twelve: // 連帯債務者１２
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.thirteen: // 連帯債務者１３
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.fourteen: // 連帯債務者１４
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.fifteen: // 連帯債務者１５
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.sixteen: // 連帯債務者１６
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.seventeen: // 連帯債務者１７
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.eighteen: // 連帯債務者１８
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.nineteen: // 連帯債務者１９
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_20
            )
          .map(data => data.cb_id);
      case guarantors_limit.twenty:
        return [];
      default:
        // 未選択・0人
        return child_shelfs
          .filter(
            child_shelf =>
            child_shelf.cb_kind === shelf_type.guarantor_1 ||
            child_shelf.cb_kind === shelf_type.guarantor_2 ||
            child_shelf.cb_kind === shelf_type.guarantor_3 ||
            child_shelf.cb_kind === shelf_type.guarantor_4 ||
            child_shelf.cb_kind === shelf_type.guarantor_5 ||
            child_shelf.cb_kind === shelf_type.guarantor_6 ||
            child_shelf.cb_kind === shelf_type.guarantor_7 ||
            child_shelf.cb_kind === shelf_type.guarantor_8 ||
            child_shelf.cb_kind === shelf_type.guarantor_9 ||
            child_shelf.cb_kind === shelf_type.guarantor_10 ||
            child_shelf.cb_kind === shelf_type.guarantor_11 ||
            child_shelf.cb_kind === shelf_type.guarantor_12 ||
            child_shelf.cb_kind === shelf_type.guarantor_13 ||
            child_shelf.cb_kind === shelf_type.guarantor_14 ||
            child_shelf.cb_kind === shelf_type.guarantor_15 ||
            child_shelf.cb_kind === shelf_type.guarantor_16 ||
            child_shelf.cb_kind === shelf_type.guarantor_17 ||
            child_shelf.cb_kind === shelf_type.guarantor_18 ||
            child_shelf.cb_kind === shelf_type.guarantor_19 ||
            child_shelf.cb_kind === shelf_type.guarantor_20
          )
          .map(data => data.cb_id);
    }
  }
};
